<template>
  <div v-tooltip="disableWith">
    <SfButtonDs variant="primary" :disabled="disabled" @click="clicked">
      {{ text }}
    </SfButtonDs>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { SfButtonDs } from '@silverfin/ui-components'

interface Props {
  text: string
  disableWith?: string | undefined
}

const props = withDefaults(defineProps<Props>(), {
  disableWith: undefined,
})

defineOptions({
  name: 'MarkAsFinalizedButton',
})

const disabled = computed(() => props.disableWith !== undefined)

const openModal = (): void => {
  window.modalCitizen.openModalPortal('mark-proposal-as-finalized-modal')
}

const clicked = (): void => {
  window.eventHub.$emit('saveChanges', {
    successCallback: () => {
      openModal()
    },
    errorCallback: () => {},
  })
}
</script>
